import { useCallback, useEffect, useState } from 'react';
import { ProgramsService } from '../../../services/patientmr/programs.service';
import type { PatientPrograms } from '../../../dtos/patientmr/programs.dto';

/**
 * Phase 20F: the patient's programme records. A read failure leaves `programs` null (badges and
 * the symptom quick-add simply do not show); `error` carries the message for the panel.
 */
export function usePatientPrograms(patientId: string | null | undefined) {
  const [programs, setPrograms] = useState<PatientPrograms | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!patientId) return;
    setLoading(true);
    try {
      setPrograms(await ProgramsService.get(patientId));
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load the patient programmes');
    } finally {
      setLoading(false);
    }
  }, [patientId]);

  useEffect(() => {
    setPrograms(null);
    reload();
  }, [reload]);

  return { programs, setPrograms, error, loading, reload };
}
